/**
@format
@flow
*/
import React from 'react';
import { useDispatch } from 'react-redux';
import { Helmet } from 'react-helmet-async';
import styled from 'styled-components';
import { Heading, Body } from '@ziynx/components/typography';
import { Button } from '@ziynx/components/buttons';
import Image from '@ziynx/components/images';
import { ContentContainer } from '@ziynx/components/layout';
import ActionTypes from '@ziynx/action-types';

import logo from '../assets/ZIYNX_LOGO_2.png';

const PageWrapper = styled.div`
  max-width: 560px;
  margin: 0 auto;
  padding: 96px 24px;
  text-align: center;
`;

const Section = styled.div`
  padding-bottom: 32px;
`;

// The Image component renders a full-width flex wrapper around the <img>,
// so center the image inside that wrapper.
const LogoSection = styled(Section)`
  > div {
    justify-content: center;
  }
`;

const ComingSoon = (): React$Node => {
  const dispatch = useDispatch();

  const logOut = () => {
    dispatch({ type: ActionTypes.auth.logout.START });
  };

  return (
    <>
      <Helmet>
        <title>Coming Soon | ZIYNX</title>
      </Helmet>
      <ContentContainer offsetTop={0} isVertical>
        <PageWrapper>
          <LogoSection>
            <Image src={logo} width="114px" height="24px" alt="company-logo" />
          </LogoSection>
          <Section>
            <Heading large>Thank you for being a member of the ZIYNX community</Heading>
          </Section>
          <Section>
            <Body large>We are going through an exciting transformation. Be back soon.</Body>
          </Section>
          <Button variant="primary" onClick={logOut}>Log Out</Button>
        </PageWrapper>
      </ContentContainer>
    </>
  );
};

export default ComingSoon;
